import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

/**
 * Every list on Admicity Lookups opens with the same heading. Where a school may reword the heading,
 * a pen beside it opens the wording in place.
 */
const SectionHeading = ({title, help, onSave, testId}) => {
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState(title);

    useEffect(() => {
        setText(title);
    }, [title]);

    const save = async () => {
        await onSave(text.trim());
        setEditing(false);
    };

    return (
        <Box sx={{mb: 1}} data-testid={testId}>
            {editing
                ? (
                    <Stack direction={{xs: 'column', sm: 'row'}} spacing={1} alignItems={{sm: 'center'}}>
                        <TextField
                            size="small"
                            label="Heading"
                            value={text}
                            autoFocus
                            onChange={event => setText(event.target.value)}
                            sx={{minWidth: {sm: 420}}}
                            inputProps={{'data-testid': `${testId}-input`}}
                        />
                        <Button variant="contained" disabled={!text.trim()} onClick={save}>Save</Button>
                        <Button
                            variant="text"
                            onClick={() => {
                                setText(title);
                                setEditing(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </Stack>
                )
                : (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography variant="h6" fontWeight="bold">{title}</Typography>
                        {onSave && (
                            <Tooltip title="Edit the heading">
                                <IconButton
                                    size="small"
                                    aria-label="Edit the heading"
                                    data-testid={`${testId}-edit`}
                                    onClick={() => setEditing(true)}
                                >
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                )}
            {help && (
                <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                    {help}
                </Typography>
            )}
        </Box>
    );
};

SectionHeading.propTypes = {
    title: PropTypes.string.isRequired,
    help: PropTypes.node,
    onSave: PropTypes.func,
    testId: PropTypes.string
};

export default SectionHeading;
